import api from '../../components/api'
import { WorkareaGroupWithWorkareas } from "./group"

export const getWorkareaGroups = async (jobId: number): Promise<WorkareaGroupWithWorkareas[]> => {
  return (await api.get<WorkareaGroupWithWorkareas[]>(`web/jobs/${jobId}/workarea-groups`)).data
}

export const deleteWorkareaGroup = async (jobId: number, workareaGroupId: string) => {
  await api.delete(`web/jobs/${jobId}/workarea-groups/${workareaGroupId}`)
}

export const sortWorkareaGroups = async (jobId: number, groupIds: string[]) => {
  await api.put(`web/jobs/${jobId}/workarea-groups/sort`, { groupIds })
}

export const sortWorkareas = async (jobId: number, workareaIds: Record<string, number[]>) => {
  await api.put(`web/jobs/${jobId}/workareas/sort`, { workareaIds })
}

export type MoveWorkareaRequest = {
  jobId: number;
  workareaId: number;
  destinationGroupId: string;
  sortOrdering: Record<string, number[]>;
};

export const moveWorkarea = async (request: MoveWorkareaRequest): Promise<void> => {
  await api.post<void>(`web/jobs/${request.jobId}/workarea-groups/move-workarea`, request)
}

export type MoveWorkareaToHiddenGroupRequest = {
  jobId: number
  workareaId: number
}

export const moveWorkareaToHiddenGroup = async (request: MoveWorkareaToHiddenGroupRequest): Promise<void> => {
  await api.post<void>(`web/jobs/${request.jobId}/workarea-groups/move-workarea-to-hidden-group`, request)
}

export type WorkareaQuotedPriceChange = {
  workareaId: number
  quotedPrice: number
  setCustomQuotedPrice: boolean
}

export type PartialWorkareaGroupUpdate = {
  id: string
  jobId: number
  fieldsToUpdate: string[]
  name?: string
  pricingType?: number
  customerAndInvoiceNotes?: string
  invoiceDescription?: string
  isOnHold?: boolean
  isApproved?: boolean
  workareaQuotedPriceChanges: WorkareaQuotedPriceChange[]
  qboSalesTaxId?: number | null
  showTaxInFinalPrice?: boolean
  taxRateId?: string | null
}

export const partiallyEditWorkareaGroup = async (request: PartialWorkareaGroupUpdate): Promise<void> => {
  await api.post(`web/jobs/${request.jobId}/workarea-groups/partial-update`, request)
}

export type CreateWorkareaGroupRequest = {
  jobId: number
  name: string
  pricingType: number
  customerAndInvoiceNotes: string
}

export const createWorkareaGroup = async (request: CreateWorkareaGroupRequest): Promise<string> => {
  return (await api.post(`web/jobs/${request.jobId}/workarea-groups`, request)).data.groupId
}

export type WorkareaAttachmentDetail = {
  projectWorkareaId: number | null
  workareaGroupId: string | null
  attachmentId: string
  filename: string
  name: string
  size: number
  sortOrder: number
}

export const getWorkareaAttachments = async (jobId: number): Promise<WorkareaAttachmentDetail[]> => {
  return (await api.get<WorkareaAttachmentDetail[]>(`web/jobs/${jobId}/workarea-groups/attachments`)).data
}

export const setGroupAttachments = async (jobId: number, groupId: string, attachmentIds: string[]) => {
  await api.put(`web/jobs/${jobId}/workarea-groups/${groupId}/attachments`, { attachmentIds })
}

export const setWorkareaAttachments = async (jobId: number, workareaId: number, attachmentIds: string[]) => {
  await api.put(`web/jobs/${jobId}/workarea-groups/workareas/${workareaId}/attachments`, { attachmentIds })
}
